import React, { Fragment, useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import Tabs from './tabs';
import { defaultTabs, apTabs, guestTabs } from './tabs/uniplaces';
import useFreezeHTML from '@spa/shared/hooks/freezeHTML';
import CloseRounded from '@spa/shared/svg/close-rounded';
import Hamburger from '@spa/shared/svg/hamburger';
import LanguageSelector from '@spa/shared/components/LanguageSelector';
import { Nav, Input, Wrapper, Menu, Item, UniversityLogo, PartnerLogo } from './styles';
import { decideTab } from '@spa/shared/utils/decideTabs';

const HeaderMobile = ({
  isLoggedIn,
  isAccommodationProvider,
  changeLanguageHandler,
  Logo,
  handleAfterMenuIsToggled = () => {},
  tabs,
  hideUserTabs,
  isSticky,
  guestName,
  changeLanguageByUrlHandler
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenuOpened = () => {
    setMenuOpen(!menuOpen);
    handleAfterMenuIsToggled(menuOpen);
  };

  const hamburgerMenu = useMemo(() => {
    const Icon = menuOpen ? CloseRounded : Hamburger;

    return <Icon className={!menuOpen ? 'hamburger' : ''} onClick={toggleMenuOpened} />;
  }, [menuOpen]);

  useFreezeHTML(menuOpen);
  const theme = useContext(ThemeContext);

  const decideTabValue = decideTab(isLoggedIn, isAccommodationProvider, defaultTabs, apTabs, guestTabs);

  return (
    <Nav isSticky={isSticky}>
      <Fragment>
        <Input type="checkbox" checked={menuOpen} onChange={toggleMenuOpened} />
        <Wrapper>
          {theme.mobileLogoURL ? (
            <UniversityLogo src={theme.mobileLogoURL} />
          ) : theme.partnerLogoUrl ? (
            <PartnerLogo src={theme.partnerLogoUrl} />
          ) : (
            <Logo onlyIcon={isSticky} />
          )}
          {hamburgerMenu}
        </Wrapper>
        <Menu className="authlist">
          <Tabs
            isLoggedIn={isLoggedIn}
            tabs={tabs ?? decideTabValue}
            isAccommodationProvider={isAccommodationProvider}
            hideUserTabs={hideUserTabs}
            guestName={guestName}
          />
          <Item>
            <LanguageSelector
              onSelect={changeLanguageHandler}
              changeLanguageByUrlHandler={changeLanguageByUrlHandler}
            />
          </Item>
        </Menu>
      </Fragment>
    </Nav>
  );
};

HeaderMobile.propTypes = {
  changeLanguageHandler: PropTypes.func.isRequired,
  tabs: PropTypes.array,
  isLoggedIn: PropTypes.bool,
  isAccommodationProvider: PropTypes.bool,
  handleAfterMenuIsToggled: PropTypes.func,
  Logo: PropTypes.func,
  hideUserTabs: PropTypes.bool,
  isSticky: PropTypes.bool,
  guestName: PropTypes.string,
  changeLanguageByUrlHandler: PropTypes.bool
};

export default HeaderMobile;
